import React from 'react'
import { Text, View, StyleSheet, Font } from '@react-pdf/renderer'

Font.register({
    family: 'Inter',
    fonts: [
        { src: `${process.env.PUBLIC_URL}/font/Inter-Regular.ttf` }
    ]
})

const styles = StyleSheet.create({
    scaleBarMarkers: {
        width: 1,
        height: 5,
    },
    scaleBarMarkersLast: {
        width: 1,
        height: 5,
    },
});

const initialValue = -10;
const endValue = 18;
const finalArray = [];

for (let n = initialValue; n <= endValue; n += 2) {
    finalArray.push({ label: n });
}

const ScaleBarBars = () => {
    return (
        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            {finalArray.map((item, index) => {

                let marginLeftValue;
                if (index < 5) { 
                    marginLeftValue = -6;
                } else if (index < 10) { 
                    marginLeftValue = -4;
                } else { 
                    marginLeftValue = -7;
                }

                return (
                    <View key={index} style={{ width: '6.66%' }}>
                        <View style={styles.scaleBarMarkers}></View>
                        <View>
                            <Text
                                style={{
                                    fontFamily: 'Inter',
                                    fontSize: 8,
                                    zIndex: 50,
                                    backgroundColor: '#fff',
                                    marginLeft: marginLeftValue,
                                }}
                            >{item.label}</Text>
                        </View>
                    </View>
                );
            })}
            <View>
                <View style={styles.scaleBarMarkersLast}></View>
                <View>
                    <Text style={{ fontSize: 8, marginLeft: -7 }}>20</Text>
                </View>
            </View>
        </View>
    )
}

export default ScaleBarBars